export default __webpack_public_path__ + "static/media/TeamReminder.c2fbf6b3.png";